import { BreadcrumbValues } from "@emisgroup/cohort-builder-kit";

export type BreadcrumbValue = BreadcrumbValues | undefined;

export interface ClickedItemType {
  /**
   * Selected Item from screen
   */
  clickedItem: BreadcrumbValue;
  /**
   * Breadcrumb clicked Item
   */
  breadcrumbSelectedItem: BreadcrumbValue;
}

export interface InitialState {
  clickedItem: BreadcrumbValue;
  breadcrumbSelectedItem: BreadcrumbValue;
}

/**
 * Moving this enum to a local version to avoid an error with exported const enums in CBK, see link for details:
 * https://stackoverflow.com/questions/50365598/typescript-runtime-error-cannot-read-property-of-undefined-enum
 */
export enum BreadcrumbValueOptions {
  SUMMARY = "summary",
  REPORTS = "reports",
  VIEWREPORT = "view-report",
  EXECUTION = "execution",
  VIEWEXECUTION = "view-execution",
  BATCH = "batch",
  INCLUDED = "included",
  EXCLUDED = "excluded"
}
